import type { ReduxState } from "../reducers";
import type { IOrderProducedModelEx } from "../linesOrders";
import type { LineOrders } from "../linesOrders";
import type { RecommendPlan } from "./recommendPlan";

export const selectSingleLineMode = (state: ReduxState): boolean => {
    const filters = state.gantt_chart_filters;
    return filters.selected_line_uuids.length === 1 && filters.is_filter_locked;
};

export const getRecommendIncludeUnscheduledStock = (recommendPlans: RecommendPlan[]): boolean => {
    if (!recommendPlans || recommendPlans.length === 0) {
        return false;
    }

    const lastPlan = recommendPlans[recommendPlans.length - 1];
    return lastPlan?.parameters?.state?.recommend_param_use_productions_of_unscheduled_operations ?? false;
};

export type OrderLineLocation = {
    line_uuid: string;
    is_unscheduled: boolean;
    order: IOrderProducedModelEx;
};

const findOrderLocationInLines = (
    lines: LineOrders[],
    order_uuid: string,
    is_unscheduled: boolean
): OrderLineLocation | undefined => {
    for (const line of lines) {
        const order = line.orders.find(o => o.uuid === order_uuid);
        if (order) {
            return { line_uuid: line.line_uuid, is_unscheduled, order };
        }
    }
    return undefined;
};

export const selectOrderLineLocation = (state: ReduxState, order_uuid: string): OrderLineLocation | undefined => {
    const { lines_orders, unscheduled_orders } = state.gantt_chart_lines_orders;
    return (
        findOrderLocationInLines(lines_orders, order_uuid, false) ??
        findOrderLocationInLines(unscheduled_orders, order_uuid, true)
    );
};

export const selectOrderByUuid = (state: ReduxState, order_uuid: string): IOrderProducedModelEx | undefined =>
    selectOrderLineLocation(state, order_uuid)?.order;
